// extracted by mini-css-extract-plugin
module.exports = {"detail":"Detail_detail__3499E","description":"Detail_description__4kJfg","page":"Detail_page__3C0Ll"};